const connectedWapps = new Set<string>()

export function addToConnectedWapps(wappSessionId: string) {
  connectedWapps.add(wappSessionId)
}

export function removeFromConnectedWapps(wappSessionId: string) {
  connectedWapps.delete(wappSessionId)
}

export function isWappConnected(wappSessionId: string) {
  return connectedWapps.has(wappSessionId)
}
